import { useWidgetLoaderData, useWidgetNavigate } from '@/core/widgets/export';
import { NewsEvent } from '@/modules/calendar/model/calendar/news-event';
import { Button, Col, Row } from 'react-bootstrap';
import EventDetailsDataTable from '@/modules/calendar/components/data-calendar/details/event-details-data-table';
import useDataReleaseHistory from '@/modules/calendar/hooks/use-data-release-history';
import DataReleaseHistoryTable from '@/modules/calendar/components/data/data-release-history-table';
import DataReleaseHistoryChart from '@/modules/calendar/components/data/data-release-history-chart';
import { CountryFlag } from '@/shared/components/export';
import dayjs from 'dayjs';

export default function DeepDiveEvent() {
  const event: NewsEvent = useWidgetLoaderData() as NewsEvent;

  const navigate = useWidgetNavigate();

  const { events, selectedRelease, canExpandHistory, expandHistory } = useDataReleaseHistory(
    event?.dataReleaseId || -1,
  );

  return (
    <>
      <div className={'d-flex justify-content-between align-items-center'}>
        <div className={'me-2'}>
          <CountryFlag country={event.country} width={48} />
        </div>

        <h1>{event.title}</h1>
        <div className={'ms-auto'}>
          <Button variant={'tertiary'} onClick={() => navigate(-1)}>
            Back
          </Button>
        </div>
      </div>

      <p>{dayjs(event.date).format('MMMM D, YYYY, h:mm a')}</p>

      <Row>
        <Col md={6}>
          <h3>This Event</h3>
          <EventDetailsDataTable event={event} date={event.date} />
        </Col>

        {selectedRelease && (
          <>
            <Col md={6}>
              <h3>Historical Graph</h3>
              <DataReleaseHistoryChart
                events={events}
                selectedRelease={selectedRelease}
                highlightDate={event.date}
                dedicatedView
                canExpandHistory={canExpandHistory}
                onExpandHistory={expandHistory}
              />
            </Col>
            <Col md={12}>
              <h3>Historical Data</h3>
              <DataReleaseHistoryTable events={events} selectedRelease={selectedRelease} />
            </Col>
          </>
        )}
      </Row>
    </>
  );
}
